import { HalResource } from '../hal/models/HalResource';
import { Hub } from './Hub';
import { Page } from './Page';
/**
 * Supported validation levels
 */
export var ValidationLevel;
(function (ValidationLevel) {
    ValidationLevel["SLOT"] = "SLOT";
    ValidationLevel["CONTENT_TYPE"] = "CONTENT_TYPE";
    ValidationLevel["PARTIAL"] = "PARTIAL";
})(ValidationLevel || (ValidationLevel = {}));
/**
 * Content type schema
 */
export class ContentTypeSchema extends HalResource {
    constructor() {
        super(...arguments);
        /**
         * Resources and actions related to a ContentTypeSchema
         */
        this.related = {
            /**
             * Retrieves the Hub this content type schema is stored in
             */
            hub: () => this.fetchLinkedResource('hub', {}, Hub),
            /**
             * Updated content type schema
             * @param updated
             */
            update: (mutation) => this.updateResource(mutation, ContentTypeSchema),
            /**
             * Archive content type schema
             */
            archive: () => this.performActionThatReturnsResource('archive', {}, { version: this.version }, ContentTypeSchema),
            /**
             * Unarchive content type schema
             */
            unarchive: () => this.performActionThatReturnsResource('unarchive', {}, { version: this.version }, ContentTypeSchema),
        };
    }
}
/**
 * @hidden
 */
export class ContentTypeSchemaPage extends Page {
    constructor(data) {
        super('content-type-schemas', ContentTypeSchema, data);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudFR5cGVTY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL21vZGVsL0NvbnRlbnRUeXBlU2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSwyQkFBMkIsQ0FBQztBQUN4RCxPQUFPLEVBQUUsR0FBRyxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBQzVCLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxRQUFRLENBQUM7QUFFOUI7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxlQUlYO0FBSkQsV0FBWSxlQUFlO0lBQ3pCLGdDQUFhLENBQUE7SUFDYixnREFBNkIsQ0FBQTtJQUM3QixzQ0FBbUIsQ0FBQTtBQUNyQixDQUFDLEVBSlcsZUFBZSxLQUFmLGVBQWUsUUFJMUI7QUFFRDs7R0FFRztBQUNILE1BQU0sT0FBTyxpQkFBa0IsU0FBUSxXQUFXO0lBQWxEOztRQStDRTs7V0FFRztRQUNhLFlBQU8sR0FBRztZQUN4Qjs7ZUFFRztZQUNILEdBQUcsRUFBRSxHQUFpQixFQUFFLENBQUMsSUFBSSxDQUFDLG1CQUFtQixDQUFDLEtBQUssRUFBRSxFQUFFLEVBQUUsR0FBRyxDQUFDO1lBRWpFOzs7ZUFHRztZQUNILE1BQU0sRUFBRSxDQUFDLFFBQTJCLEVBQThCLEVBQUUsQ0FDbEUsSUFBSSxDQUFDLGNBQWMsQ0FBQyxRQUFRLEVBQUUsaUJBQWlCLENBQUM7WUFFbEQ7O2VBRUc7WUFDSCxPQUFPLEVBQUUsR0FBK0IsRUFBRSxDQUN4QyxJQUFJLENBQUMsZ0NBQWdDLENBQ25DLFNBQVMsRUFDVCxFQUFFLEVBQ0YsRUFBRSxPQUFPLEVBQUUsSUFBSSxDQUFDLE9BQU8sRUFBRSxFQUN6QixpQkFBaUIsQ0FDbEI7WUFFSDs7ZUFFRztZQUNILFNBQVMsRUFBRSxHQUErQixFQUFFLENBQzFDLElBQUksQ0FBQyxnQ0FBZ0MsQ0FDbkMsV0FBVyxFQUNYLEVBQUUsRUFDRixFQUFFLE9BQU8sRUFBRSxJQUFJLENBQUMsT0FBTyxFQUFFLEVBQ3pCLGlCQUFpQixDQUNsQjtTQUNKLENBQUM7SUFDSixDQUFDO0NBQUE7QUFFRDs7R0FFRztBQUNILE1BQU0sT0FBTyxxQkFBc0IsU0FBUSxJQUF1QjtJQUNoRSxZQUFZLElBQVU7UUFDcEIsS0FBSyxDQUFDLHNCQUFzQixFQUFFLGlCQUFpQixFQUFFLElBQUksQ0FBQyxDQUFDO0lBQ3pELENBQUM7Q0FDRiJ9